module.exports = __webpack_public_path__ + "img/17860_L.a4faabff.png";